<!--We were checking url is ICM page or dotCMS page using regex pattern-->
@if (isContentPage$ | async) {
<ish-content-page />
} @else {
<custom-lazy-dot-cms-default-page *ishFeature="'dotCms'" />
}
